<template>
    <div class="agency-create">

        <data-form title="Create Agency"
                   tag="agency-create"
                   save-button-label="Submit"
                   :field-model="agencyFields"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/agency/list"
                   submit-success-message="Agency Created"
                   submit-error-message="Error Creating Agency">
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import AgencyFields from '@/models/Agency'

export default Vue.extend({
    name: 'AgencyCreate',
    data () {
        return {
            agencyFields: AgencyFields,
            fieldGroups: [
                ['name', 'abbreviation'],
                ['status'],
            ],
        }
    },
    methods: {
        onSubmit (modelInstance) {
            return this.$api.createItem(this, 'agency', modelInstance)
                .then((response) => {
                    if (response.body.id) {
                        this.$router.push(`/agency/view/${response.body.id}`)
                    }
                })
        }
    }
})

</script>
